import {Component} from "@/event/calendar/dom/Component.ts";
import {DrawingContext} from "@/event/calendar/dom/DrawingContext.ts";
import {Rect} from "@/event/calendar/Shapes.ts";
import {DaysCorner} from "@/event/calendar/days/DaysCorner.ts";
import {ScrollComponent} from "@/event/calendar/dom/ScrollComponent.ts";

export class DaysHeader extends Component {
	private corner: DaysCorner;
	private header: ScrollComponent;

	constructor(corner: DaysCorner, topHeader: ScrollComponent) {
		super();
		this.corner = corner;
		this.header = topHeader;
		this.append(this.corner).append(this.header);
	}

	protected drawBackground(dc: DrawingContext, area: Rect) {
		dc.ctx.fillStyle = dc.style.getPropertyValue("--cal-header-bg");
		dc.ctx.fillRect(area.x, area.y, area.width, area.height);
	}


	protected drawBorder(dc: DrawingContext, area: Rect) {
		dc.ctx.strokeStyle = dc.style.getPropertyValue("--cal-header-separ");
		dc.ctx.beginPath();
		dc.ctx.moveTo(0, this.height - 0.5);
		dc.ctx.lineTo(this.width, this.height - 0.5);
		dc.ctx.stroke();
	}

	placeChildren(dc: DrawingContext, cb: Rect) {
		this.corner.x = cb.x;
		this.corner.y = cb.y;
		this.corner.width = this.corner.gutterWidth;
		this.corner.height = cb.height - 1;

		this.header.x = cb.x + this.corner.gutterWidth;
		this.header.y = cb.y;
		this.header.width = cb.width - this.corner.gutterWidth;
		this.header.height = cb.height - 1;
	}
}